<div class="p-2 col-lg-8 col-xl-7">
  <div
    id="profile-card"
    class="d-flex flex-column align-items-center align-items-lg-start gap-4"
  >
    <div id="top-section" class="d-flex flex-row gap-0 align-items-center">
      <div id="profile-picture" class="profile-image-circle">
        <img
          [src]="
            userProfileUrl
              ? userProfileUrl
              : '../../../assets/images/img_avatar_blank.avif'
          "
          alt="Profile Image"
        />
      </div>
      <div id="edit-profile-picture-button" (click)="openCamPopup()">
        <i class="fa-solid fa-pen"></i>
      </div>

      <div id="name-contact-details">
        <div
          class="d-flex flex-row align-items-center gap-3"
          [class.pe-3]="!hasMultipleAccountsLinked"
        >
          <div class="fs-3 flex-grow-1 text-break">
            {{ userDetails?.first_name }} {{ userDetails?.last_name }}
          </div>
          @if (!hasMultipleAccountsLinked) {
            <div
              (click)="openSelectAccountTemplate()"
              role="button"
              id="add-account-button"
            >
              <div
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Sign In As Another User"
              >
                <i class="fa-solid fa-user-plus"></i>
              </div>
            </div>
          }
        </div>
        <div class="mb-2 text-break d-flex gap-2 align-items-center small">
          <i class="fa-solid fa-envelope"></i> {{ userDetails?.email }}
        </div>
        @if (userDetails?.mobile_number) {
          <div class="mb-2">
            <i class="fa-solid fa-phone"></i> {{ userDetails?.mobile_number }}
          </div>
        }
      </div>
    </div>

    <div id="buttons">
      <div
        class="d-flex column-gap-2 row-gap-4 gap-lg-2 flex-wrap justify-content-end"
      >
        <div
          class="hover border small p-1 px-3 bg-primary text-white rounded fw-semibold"
          role="button"
          (click)="editProfile(profileDialog)"
        >
          Edit Profile
        </div>

        @if (userDevicesListData?.web_authn?.length < 1) {
          <div
            class="hover border small p-1 px-2 bg-success text-white rounded fw-semibold d-flex align-items-center"
            role="button"
            (click)="fidoRegister()"
          >
            Sign In Faster with a Passkey <i class="fa-solid fa-key ps-2"></i>
          </div>
        } @else {
          <div>
            <div
              class="hover border small p-1 px-3 bg-white border-success text-success rounded fw-semibold d-flex align-items-center"
              role="button"
              (click)="openTemplate(userDevicesTemplateRef)"
            >
              Manage Passkeys
            </div>
          </div>
        }

        <div
          class="hover border small p-1 px-2 bg-white text-primary border-primary rounded fw-semibold d-flex align-items-center"
          role="button"
          (click)="openPasswordForm()"
        >
          Change Password <i class="fa-solid fa-lock ps-2"></i>
        </div>
        @if (isAdmin || isDispatchUser) {
          <div
            class="hover border small p-1 px-2 bg-warning text-dark border-warning rounded fw-semibold d-flex align-items-center"
            role="button"
            (click)="openTemplate(emailAlertConfigTemplate)"
          >
            Email Notifications <i class="fa-solid fa-bell ps-2"></i>
          </div>
        }
      </div>
    </div>

    <div id="bottom-section">
      <dl>
        <dt>Timezone</dt>
        <dd>
          {{ userDetails?.time_zone }}
          {{ userDetails?.timeZone?.gmtOffset }}
        </dd>
      </dl>

      <dl class="col-lg-6">
        <dt>Notification Volume</dt>
        <dd class="d-flex justify-content-center mb-2">
          <input
            style="width: 95%"
            type="range"
            [min]="0"
            placeholder="Notification Volume"
            [max]="100"
            [(ngModel)]="muteNotification"
            (change)="changeNotificationVolume()"
          />
          <span class="ms-2 fw-bold">{{ muteNotification }}</span>
        </dd>
      </dl>

      <gtapp-identification></gtapp-identification>
    </div>
  </div>
</div>

<ng-template #profileDialog let-profileRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Edit Profile
      <span class="float-end" (click)="profileRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <form [formGroup]="profileForm">
        <div class="d-flex flex-column gap-2">
          <div class="col-12 form-floating">
            <input
              class="form-control"
              type="text"
              formControlName="first_name"
              id="first_name"
              maxlength="150"
              required
            />
            <label for="first_name">First Name</label>
          </div>
          <div class="col-12 form-floating">
            <input
              class="form-control"
              type="text"
              formControlName="last_name"
              id="last_name"
              maxlength="150"
              required
            />
            <label for="last_name">Last Name</label>
          </div>
          <div class="col-12 form-floating">
            <input
              class="form-control"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              minlength="7"
              maxlength="10"
              (input)="mobileNumberCheck()"
              formControlName="mobile_number"
              id="mobile_number"
            />
            <label for="mobile_number">Phone</label>
            @if (
              profileForm.controls["mobile_number"].invalid &&
              profileForm.controls["mobile_number"].touched
            ) {
              <div class="text-danger">Invalid mobile number</div>
            }
          </div>
          <div class="col-12 form-floating">
            <select
              class="form-control"
              formControlName="time_zone"
              id="timeZone"
              (change)="onTimeZoneChange($event)"
            >
              @for (timeZone of stateTimeZones; track timeZone) {
                <option [value]="timeZone.value">
                  {{ timeZone.value }} {{ timeZone.gmtOffset }}
                </option>
              }
            </select>
            <label for="timeZone">Timezone</label>
          </div>
          <div class="row row-cols-2 mt-2">
            <div class="col">
              <button
                type="button"
                class="btn btn-dark w-100 btn-lg"
                (click)="profileRef.close()"
              >
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-primary w-100 btn-lg"
                (click)="updateProfileDetails(); profileRef.close()"
                [disabled]="!profileForm.valid"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updateEmailTemplateRef let-updateEmailTemplateRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Change Email Address
      <span class="float-end" (click)="updateEmailTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <form [formGroup]="emailUpdateForm" appFormEnterAction>
      @if (emailUpdateStepper === 1) {
        <div class="form-floating mb-3">
          <input
            type="email"
            class="form-control"
            [class.is-invalid]="
              emailUpdateForm.controls['new_email'].invalid &&
              emailUpdateForm.controls['new_email'].touched
            "
            formControlName="new_email"
            id="new_email"
            autocomplete="off"
            placeholder="Email Address"
            autofocus
            autocorrect="off"
            autocapitalize="off"
            (keyup.enter)="
              emailUpdateForm.valid ? sendVerificationCode() : null
            "
          />
          <label for="new_email">New Email Address</label>
          @if (
            emailUpdateForm.controls["new_email"].invalid &&
            emailUpdateForm.controls["new_email"].touched
          ) {
            <div class="invalid-feedback">Invalid email address</div>
          }
        </div>
        <div class="row row-cols-2">
          <div class="col">
            <button
              (click)="updateEmailTemplateRef.close()"
              class="btn btn-lg btn-secondary w-100"
              type="button"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              (click)="sendVerificationCode()"
              class="btn btn-lg btn-primary w-100"
              type="button"
              [disabled]="emailUpdateForm.invalid"
            >
              Verify
            </button>
          </div>
        </div>
      }
      @if (emailUpdateStepper === 2) {
        <div class="mb-3">
          <div class="mb-2">
            Enter the verification code sent to your new email to confirm email
            change.
          </div>
          <div class="fw-semibold">
            Failure to carry out this action means your email address will NOT
            change.
          </div>
        </div>
        <div class="form-floating">
          <input
            class="form-control"
            type="tel"
            inputmode="numeric"
            pattern="[0-9]*"
            [class.is-invalid]="
              emailUpdateForm.controls['v_code'].invalid &&
              emailUpdateForm.controls['v_code'].touched
            "
            formControlName="v_code"
            id="verCode"
            placeholder="Verification Code"
            [maxlength]="6"
            autofocus
            autocomplete="off"
            (input)="emailUpdateForm.valid ? updateEmailAddress() : null"
          />
          <label for="verCode">Verification Code</label>
          @if (
            emailUpdateForm.controls["v_code"].invalid &&
            emailUpdateForm.controls["v_code"].touched
          ) {
            <div class="invalid-feedback">Verification code is required!</div>
          }
        </div>
        <div class="row row-cols-2 mt-3">
          <div class="col">
            <button
              (click)="updateEmailTemplateRef.close()"
              class="btn btn-lg btn-secondary w-100"
              type="button"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              (click)="updateEmailAddress(); updateEmailTemplateRef.close()"
              class="btn btn-lg btn-primary w-100"
              type="button"
              [disabled]="emailUpdateForm.invalid"
            >
              Confirm
            </button>
          </div>
        </div>
      }
    </form>
  </div>
</ng-template>

<ng-template #userDevicesTemplateRef let-userDevicesTemplateRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Your Passkeys
      <span class="float-end" (click)="userDevicesTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="mb-2">
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="webauthn-devices"
          role="tabpanel"
          aria-labelledby="webauthn-devices-tab"
        >
          @for (
            device of userDevicesListData?.web_authn;
            track device;
            let i = $index
          ) {
            <div>
              <div class="d-flex mx-2 my-3 border rounded p-2">
                <div class="flex-grow-1 d-flex align-items-center">
                  <div class="d-flex gap-2 flex-wrap small">
                    <span class="text-secondary">
                      <i class="fa-solid fa-key"></i>
                    </span>
                    @if (
                      device?.device?.device &&
                      device?.device?.device?.toLowerCase() != "unknown"
                    ) {
                      <span>
                        {{ device?.device?.device }}
                      </span>
                    }
                    @if (
                      device?.device?.device_type &&
                      device?.device?.device_type?.toLowerCase() != "unknown"
                    ) {
                      <span>
                        {{ device?.device?.device_type | titlecase }} &nbsp;
                      </span>
                    }
                    <span>
                      {{ device?.device?.device_os }}
                      {{ device?.device?.browser }}
                      {{ device?.device?.browser_version }}
                    </span>
                    @if (device?.last_used_at) {
                      <div class="text-secondary">
                        Last Used
                        {{ device?.last_used_at | customDate: "d-MMM y HH:mm" }}
                      </div>
                    }
                  </div>
                </div>
                <div (click)="deleteUserDevice(device, 'web_authn')">
                  <button class="btn btn-sm btn-danger">Delete</button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="col">
      @if (userDevicesListData?.web_authn?.length < 5) {
        <button
          [disabled]="!isTrustedDevice"
          class="btn btn-success w-100 btn-lg"
          (click)="fidoRegister()"
        >
          Create a Passkey
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template
  #emailAlertConfigTemplate
  let-emailAlertConfigTemplateRef="dialogRef"
>
  <div class="card dialog-box p-2">
    <div class="card-header">
      Email Settings
      <span class="float-end" (click)="emailAlertConfigTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="px-lg-5">
      <div class="mt-3 mb-5">Select which emails you want to subscribe to.</div>

      <div class="d-flex flex-column overflow-auto" style="max-height: 50vh">
        <div class="d-flex align-items-center ps-2 gap-2 mb-3 fw-semibold">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="allEmailAlertsOn"
            (change)="selectAllAlerts($event)"
          />
          Select All / None
        </div>

        <div class="accordion accordion-flush" id="emailConfigAccordian">
          <div class="accordion-item">
            <div class="accordion-header">
              <div class="d-flex align-items-center ps-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="userDetails?.job_notification"
                  (change)="
                    userDetails.job_notification =
                      !userDetails?.job_notification;
                    checkAllAlertsSelected()
                  "
                />
                <button
                  class="list-group-item border-0 py-3 collapsed ms-2 ps-2 rounded"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  Completed Jobs
                </button>
              </div>
            </div>
            <div
              id="flush-collapseOne"
              class="accordion-collapse collapse d-none"
              data-bs-parent="#emailConfigAccordian"
            >
              <div class="accordion-body">
                <div class="mb-3"></div>
              </div>
            </div>
          </div>
          @for (item of emailNotificationListData; track $index) {
            <div class="accordion-item">
              <div class="accordion-header">
                <div class="d-flex align-items-center ps-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [checked]="!emailAlertNotificationConfig?.[item?.key]"
                    (change)="
                      emailAlertNotificationConfig[item?.key] =
                        !emailAlertNotificationConfig?.[item?.key];
                      checkAllAlertsSelected()
                    "
                  />
                  <button
                    class="collapsed ms-2 ps-2 rounded"
                    [ngClass]="
                      item?.[emailAlertNotificationConfig[item?.key]]
                        ? 'accordion-button'
                        : 'list-group-item border-0 py-3'
                    "
                    type="button"
                    data-bs-toggle="collapse"
                    aria-expanded="false"
                    [attr.data-bs-target]="'#flush-collapse' + item?.key"
                    [attr.aria-controls]="'flush-collapse' + item?.key"
                  >
                    {{ item?.label }}
                  </button>
                </div>
              </div>
              @if (item?.[emailAlertNotificationConfig[item?.key]]) {
                <div
                  [id]="'flush-collapse' + item?.key"
                  class="accordion-collapse collapse"
                  data-bs-parent="#emailConfigAccordian"
                >
                  <div class="accordion-body">
                    <div class="mb-3">
                      {{ item?.[emailAlertNotificationConfig[item?.key]] }}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          (click)="emailAlertConfigTemplateRef.close()"
          class="btn btn-lg btn-secondary w-100"
          type="button"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          (click)="
            emailAlertConfigTemplateRef.close();
            updateEmailAlertNotificationSetting()
          "
          class="btn btn-lg btn-primary w-100"
          type="button"
        >
          Update Settings
        </button>
      </div>
    </div>
  </div>
</ng-template>
